export enum Section {
  Beginning = 'beginning',
  Conclusion = 'conclusion',
}

export enum FormFieldName {
  ImageS3Name = 'ImageS3Name',
}
